import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/storage'
import 'firebase/firestore'
import 'firebase/functions'
//import 'firebase/messaging'   

const config = {
  apiKey: "AIzaSyDuvfs53JLg2TcC8F574JZNSDfBUm8J9vE",
  authDomain: "nativeux.firebaseapp.com",
  databaseURL: "https://nativeux.firebaseio.com",
  projectId: "nativeux",
  storageBucket: "nativeux.appspot.com",
  messagingSenderId: "673453036747",
  appId: "1:673453036747:web:3ae734621da81d5dfd374e"
}

// Development
// {
//   apiKey: "AIzaSyD5-FkUQcaFRYX0C-mbMYk00p8nxJuJPuA",
//   authDomain: "native-development.firebaseapp.com",
//   databaseURL: "https://native-development.firebaseio.com",
//   projectId: "native-development",
//   storageBucket: "native-development.appspot.com",
//   messagingSenderId: "1087111572710",
//   appId: "1:1087111572710:web:a954512b7b2a3be75c1f27",
//   measurementId: "G-NHF7J95ZS5"
// }

const fireb = firebase.initializeApp(config)
firebase.firestore().enablePersistence({
  synchronizeTabs: true
})

export default fireb